import { render, staticRenderFns } from "./PosInventoryAdd.vue?vue&type=template&id=2581b0a9&scoped=true&"
import script from "./PosInventoryAdd.vue?vue&type=script&lang=js&"
export * from "./PosInventoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2581b0a9",
  null
  
)

export default component.exports